module.exports = __webpack_public_path__ + "static/img/blog_lg_portrait.13f4cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/blog_lg_portrait.png
// module id = x8qc
// module chunks = 1